




























































import Vue from 'vue'

import ModalFullScreen from '@/common/components/ModalFullScreen.vue'
import SizeInputMobile from '@/product/components/SizeInputMobile.vue'
import SizeInputRequest from '@/product/components/SizeInputRequest.vue'
import { Button } from '@raksul/raksul-common-ui'

import {
  sizeInputError,
  limitMaxQuantityInputError
} from '@/common/utils/common'
import { SkuSize } from '@/product/types'

export default Vue.extend({
  components: {
    ModalFullScreen,
    Button,
    SizeInputMobile,
    SizeInputRequest
  },
  props: {
    sizes: {
      type: Array as () => Array<SkuSize>,
      required: true
    },
    currentColorPatternName: {
      type: String,
      required: true
    },
    printableSkuId: {
      type: [String, Number],
      required: true
    },
    quantityUnit: {
      type: String,
      required: true
    },
    maxTotalQuantity: {
      type: Number,
      required: true
    },
    outOfStockSizeMessage: {
      type: String,
      required: true
    },
    hasAdditionalOptions: {
      type: Boolean,
      required: true
    }
  },
  data(): {
    modalDisplayedSizes: Array<SkuSize>,
  } {
    return {
      modalDisplayedSizes: this.sizes.map((size: SkuSize) => ({ ...size }))
    }
  },
  computed: {
    currentTotalQuantity(): number {
      return this.modalDisplayedSizes.reduce((total: number, size: SkuSize) => total + size.quantity, 0)
    },
    disableSubmit(): boolean {
      return this.modalDisplayedSizes.some((size: SkuSize) => size.quantity > size.maxQuantity)
        || this.isOverFastShippingMaxQuantity
    },
    isOverFastShippingMaxQuantity(): boolean {
      return this.maxTotalQuantity > -1 && this.currentTotalQuantity > this.maxTotalQuantity
    },
    errors(): Array<string> {
      const errors: Array<string> = []
      if (this.outOfStockSizeMessage) {
        errors.push(this.outOfStockSizeMessage)
      }
      if (this.isOverFastShippingMaxQuantity) {
        errors.push(this.limitMaxQuantityInputError(this.currentColorPatternName, this.maxTotalQuantity))
      }
      return errors
    }
  },
  methods: {
    sizeInputError,
    limitMaxQuantityInputError,
    inputSizeQuantity(sizeId: string, quantity: number) {
      const size = this.modalDisplayedSizes.find((size: SkuSize) => size.id === sizeId)
      if (size) size.quantity = quantity
    }
  }
})
